import { SkupremeModal } from '@components/Modal';
import { HoverBorderButton } from '@elements/Button';
import { DangerText } from '@elements/Common';
import Barocde from 'react-barcode';
import { Message, Segment } from 'semantic-ui-react';

export const ToteBarcodePopup = ({
  toteNumber,
  isOpen,
  hasPackageLabelMismatch,
  onClose,
}) => {
  return (
    <SkupremeModal
      size="tiny"
      open={isOpen}
      onClose={onClose}
      title="Scan Barcode to Fulfill Tote"
    >
      {hasPackageLabelMismatch && (
        <Message error>
          Packed items and package labels do not match. You can still fulfill this tote,
          but regenerate the mismatched label before shipping.
        </Message>
      )}
      <Message>
        If the scanner does not detect the barcode, please try increasing the monitor's
        brightness.
      </Message>
      <Segment className="d-flex align-items-center justify-content-center">
        {toteNumber ? (
          <Barocde value={toteNumber} />
        ) : (
          <DangerText>There was a problem showing barcode</DangerText>
        )}
      </Segment>
      <div className="d-flex justify-content-end">
        <HoverBorderButton onClick={onClose}>Close</HoverBorderButton>
      </div>
    </SkupremeModal>
  );
};
